// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"95316a20","150":"8b86dcf7","161":"835f38bf","306":"39b1d509","317":"44fbc8a2","507":"b78caf1f","599":"0932540c","623":"dbc09647","672":"fcfe430f","704":"9b9b024f","756":"97ddea34","765":"4e181217","830":"8b819080","832":"f303321d","989":"e8b0426e"}[chunkId] + ".chunk.js";
};